module.exports = __webpack_public_path__ + "puyucode_chinagen.png?c45fbc58cfeec5b94291a56e3712c8d0";